/**
 * Single source of truth for the AI-scoring React Query keys.
 *
 * Call sites reached this cache two ways: `jobId` from useParams (a string) and
 * `jobData.id` from the API (a number). React Query compares keys structurally,
 * so ['fetchAiScoring', '4756'] and ['fetchAiScoring', 4756] were two separate
 * entries — the same request fired twice on every job page. Normalising to a
 * string here keeps them on one entry regardless of which value a caller holds.
 */
export const aiScoringKeys = {
  detail: (jobId?: string | number | null) =>
    [
      'fetchAiScoring',
      jobId === null || jobId === undefined || jobId === ''
        ? null
        : String(jobId),
    ] as const,
};
